import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

const config = new MatSnackBarConfig();
config.panelClass = ['save-success'];
config.horizontalPosition = 'center';
config.verticalPosition = 'top';
config.duration = 3000;

@Injectable({
  providedIn: 'root',
})
export class DefaultSnackBarService {
  constructor(private _snackBar: MatSnackBar) {}

  open(message: string) {
    this._snackBar.open(message, 'Ok', config);
  }
}
